var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuEnter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#232429"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 14.75C11 14.3358 11.3358 14 11.75 14H28.25C28.6642 14 29 14.3358 29 14.75C29 15.1642 28.6642 15.5 28.25 15.5H11.75C11.3358 15.5 11 15.1642 11 14.75ZM11 20C11 19.5858 11.3358 19.25 11.75 19.25H28.25C28.6642 19.25 29 19.5858 29 20C29 20.4142 28.6642 20.75 28.25 20.75H11.75C11.3358 20.75 11 20.4142 11 20ZM11 25.25C11 24.8358 11.3358 24.5 11.75 24.5H28.25C28.6642 24.5 29 24.8358 29 25.25C29 25.6642 28.6642 26 28.25 26H11.75C11.3358 26 11 25.6642 11 25.25Z",
    fill: "#F3F4FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuEnter);
export default __webpack_public_path__ + "static/media/icon_menu_enter.ef552162af56cd083363d26bd3cf6644.svg";
export { ForwardRef as ReactComponent };